import { enterprisePageData } from "../js/enterprisesDatamap";
import { agriculturePageData } from "../js/hiddenPageJson/agricultureJson";
import { javaPageData } from "../js/hiddenPageJson/javaDevelopmentJson";
import { generativeAIChatbotPageData } from "../js/hiddenPageJson/gen-ai-chatbotJson";
import { kotlinAppPageData } from "../js/hiddenPageJson/kotlinJson";
import { iosPageData } from "../js/hiddenPageJson/swiftIosJson";
import { aspNetPageData } from "../js/hiddenPageJson/aspnetJson";
import { pythonAppPageData } from "../js/hiddenPageJson/pythonJson";
import { angularPageData } from "../js/hiddenPageJson/angularJson";
import { dotNetPageData } from "../js/hiddenPageJson/dotnetPageJson";
import { reactJSPageData } from "../js/hiddenPageJson/reactJson";

function renderHero(hero) {
  document.querySelector(".hero-heading").textContent = hero.heading;
  document.querySelector(".hero-subtext").textContent = hero.subtext;
  document.querySelector(".hero-btn-text").textContent = hero.buttonText;
  document.querySelector(".hero-link").href = hero.link;
}

/* ================= HERO ================= */
function renderAwardSection(awardsSection) {
  document.querySelector(".awardHeading").textContent = awardsSection.title;
}

/* ================= SERVICES ================= */
function renderServices(services) {
  // heading + intro
  document.querySelector(".services-heading").textContent = services.heading;

  document.querySelector(".services-intro").textContent = services.intro;

  // cards
  const container = document.getElementById("services-container");

  container.innerHTML = services.items
    .map(
      (item) => `
    <article class="bg-offPurple rounded-xl p-4 lg:p-6 transition">
      <h3 class="font-semibold text-base lg:text-lg font-publicSans text-headingColor tracking-wide">
        ${item.title}
      </h3>
      <p class="text-headingLight text-sm mt-3 font-publicSans tracking-wide font-normal">
        ${item.desc}
      </p>
    </article>
  `,
    )
    .join("");
}

/* ================= TRUT STATS ================= */
function renderTrutStats(trutStats) {
  document.querySelector(".trutStats-heading").textContent = trutStats.heading;

  const col1 = document.getElementById("trutStats-col-1");
  const col2 = document.getElementById("trutStats-col-2");

  if (!col1 || !col2) {
    console.error("trutStats columns not found");
    return;
  }

  // split items into two columns [0,1] and [2,3]
  const col1Items = trutStats.items.slice(0, 2);
  const col2Items = trutStats.items.slice(2, 4);

  function createStatItem(item, isLast = false) {
    return `
      <div class="flex items-center xl:gap-2 2xl:gap-6">
        <div class="w-20 sm:w-28">
          <div class="text-2xl lg:text-[40px] font-publicSans text-headingColor font-semibold">
            ${item.value}
          </div>
        </div>
        <div class="flex-1">
          <div class="text-base lg:text-xl font-publicSans tracking-wide text-headingLight">
            ${item.label}
          </div>
        </div>
      </div>
      ${!isLast ? `<div class="w-full h-[1px] GradiantBGColorLine"></div>` : ""}
    `;
  }

  col1.innerHTML = col1Items
    .map((item, i) => createStatItem(item, i === col1Items.length - 1))
    .join("");

  col2.innerHTML = col2Items
    .map((item, i) => createStatItem(item, i === col2Items.length - 1))
    .join("");
}
/* =================our service CARD TEMPLATE ================= */
function createCard(item) {
  return `
    <a class="h-full block" href="${item.link}">
      <div class="flex gap-4 lg:gap-5 flex-col bg-white rounded-xl p-4 lg:p-6 border border-[#C8C8C8] h-full relative card-hover">
        
        <img src="${item.icon}"
          loading="lazy"
          alt="${item.title}"
          height="32"
          width="32"
          class="w-7 h-7 lg:w-8 lg:h-8"
        />

        <div>
          <h3 class="text-base lg:text-lg font-semibold text-headingColor font-publicSans tracking-wide">
            ${item.title}
          </h3>

          <p class="mt-3 text-headingLight font-normal font-publicSans tracking-wide text-sm lg:text-base">
            ${item.desc}
          </p>
        </div>

        <img src="https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/servicedRoowIcon.svg"
          loading="lazy"
          height="40"
          width="40"
        />
      </div>
    </a>
  `;
}

/* ================= MAIN SERVICES ================= */
function renderMainServices(mainServices) {
  const tabIds = ["tab-1", "tab-2", "tab-3"];
  mainServices.categories.forEach((category, index) => {
    const panel = document.getElementById(tabIds[index]);
    if (!panel) {
      console.error("Panel not found:", tabIds[index]);
      return;
    }

    panel.innerHTML = `
      <div class="grid grid-cols-3 gap-6">
        ${category.items.map(createCard).join("")}
      </div>
    `;
  });
}

/* =================MAIN SERVICES IN MOBILE ================= */
function renderMainServicesMobile(mainServices) {
  const container = document.getElementById("mobile_services");
  if (!container) return;

  container.innerHTML = mainServices.categories
    .map(
      (category) => `
        <div class="flex flex-col gap-4 mb-8">

          <!-- Heading -->
          <div class="text-xl">
            <h4 class="font-publicSans font-semibold text-lg text-headingColor tracking-wide">
              ${category.title}
            </h4>
          </div>

          <!-- Cards -->
          <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            ${category.items.map(createCard).join("")}
          </div>

        </div>
      `,
    )
    .join("");
}

// ====================newsLetter 1 ============
function newsLetterFun(cta) {
  document.getElementById("cta-heading").textContent = cta.heading;
  document.getElementById("cta-desc").textContent = cta.desc;
  document.getElementById("cta-btn-text").textContent = cta.buttonText;
  document.getElementById("cta-btn").href = cta.link;
}

// ==============case study =============
function createCaseStudyCard(item) {
  return `
    <li class="stack__card">
                    <a href="${item.url}">
                        <div class="rounded-3xl p-6 lg:p-[70px] relative overflow-hidden h-full" style="background:${item.color}">
                            <div class="flex flex-col-reverse lg:flex-row justify-between gap-0 lg:gap-8">
                                <!-- Left content -->
                                <div class="max-w-2xl">
                                    <div class="lg:mb-8 mb-4">
                                        <p
                                            class="text-xs lg:text-base font-normal tracking-wide uppercase text-headingColor font-publicSans">
                                            Case Study
                                        </p>
                                        <h2
                                            class="text-[24px] lg:text-3.5xl font-semibold text-headingColor font-publicSans tracking-wide lg:my-0 mb-1">
                                             ${item.title}
                                        </h2>
                                        <p
                                            class="text-sm lg:text-lg tracking-wide text-headingColor max-w-xl font-publicSans font-normal">
                                              ${item.desc}
                                        </p>
                                    </div>

                                    <!-- Results -->
                                    <div class="lg:space-y-2">
                                        <p
                                            class="text-sm lg:text-lg tracking-wide text-headingColor font-publicSans lg:font-semibold font-medium mb-1 lg:mb-0">
                                            Results</p>

                                        <div
                                            class="2xl:gap-8 flex pb-0 lg:pb-16 flex-row lg:items-start items-center justify-between lg:gap-4 gap-2">

                                             ${item.results
                                               .map((res) => {
                                                 const [value, ...text] =
                                                   res.split(" ");
                                                 return `
                                            <div class="flex lg:items-center lg:gap-4 gap-0 lg:flex-row flex-col">
                                                <p
                                                    class="text-[24px] lg:text-3.5xl font-semibold text-headingColor font-publicSans tracking-wide">
                                                    ${value}</p>
                                                <p
                                                    class="text-sm lg:text-base tracking-wide text-headingColor lg:max-w-xl font-publicSans">
                                                    ${text.join(" ")}
                                                </p>
                                            </div>
                                            `;
                                               })
                                               .join("")}
                                          
                                        </div>
                                    </div>
                                </div>

                                <!-- Right image / mockup -->
                                <div
                                    class="w-full 2xl:w-[24rem] lg:w-[28rem] flex justify-center lg:justify-end xl:justify-end 2xl:justify-end sm:mx-auto md:mx-auto lg:ml-auto lg:mr-0 sm:justify-center mb-4 lg:mb-0 md:justify-center">
                                    <img src="${item.image || ""}"
                                    alt="${item.title}"
                                        loading='lazy' alt="Run The Day dashboard"
                                        class="w-full h-full object-contain" />
                                </div>
                            </div>

                            <!-- Decorative & Button -->
                            <div
                                class="w-8 h-8 bg-white absolute left-0 bottom-[80px] lg:bottom-[112px] z-10 lg:block hidden">
                                <div class="w-8 h-8 rounded-bl-3xl"  style="background:${item.color}"></div>
                            </div>

                            <div
                                class="lg:w-28 lg:h-28 w-20 h-20 bg-white pl-0 pb-0 p-3 absolute left-0 bottom-0 rounded-tr-3xl lg:block hidden">
                                <button
                                    class="lg:w-24 lg:h-24 w-16 h-16 rounded-[16px] lg:rounded-[22px] flex items-center justify-center"
                                    type="button"  style="background:${item.color}">
                                    <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none"
                                        stroke="currentColor" width="24px" height='24px' stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round"
                                        class="lucide lucide-arrow-right-icon lucide-arrow-right">
                                        <path d="M5 12h14" />
                                        <path d="m12 5 7 7-7 7" />
                                    </svg>
                                </button>
                            </div>
                            <div
                                class="w-8 h-8 bg-white absolute left-[80px] lg:left-[112px] bottom-[0px] z-10 lg:block hidden">
                                <div class="w-8 h-8 bg-[#fff9e7] rounded-bl-3xl " style="background:${item.color}"></div>
                            </div>
                        </div>
                    </a>
                </li>`;
}
function renderCaseStudies(caseStudies) {
  const container = document.getElementById("stackList");
  if (!container) {
    console.error("stackList not found");
    return;
  }

  container.innerHTML = caseStudies.items.map(createCaseStudyCard).join("");
}

// end to end process=================
/* ================= OUR PROCESS ================= */
function renderOurProcess(ourProcess) {
  document.querySelector(".process-heading").textContent = ourProcess.heading;
  document.querySelector(".process-subtext").textContent = ourProcess.subtext;

  const container = document.getElementById("process-container");
  if (!container) {
    console.error("process-container not found");
    return;
  }

  container.innerHTML = ourProcess.steps
    .map(
      (step) => `
      <div class="relative sm:pl-24 timeline-item" data-index="${parseInt(step.number) - 1}">
        <div class="flex items-start gap-0 sm:gap-0">

          <!-- Circle indicator -->
          <div class="flex-shrink-0 flex items-center justify-center lg:pt-5 lg:mt-0 -mt-2">
            <div class="flex absolute left-0 w-16 h-16 items-center justify-center">
              <div class="step-circle w-10 h-10 bg-white rounded-full flex items-center justify-center text-gray-200 font-bold text-lg lg:text-2xl transition-all duration-300">
                ${step.number}
              </div>
            </div>
            <div class="sm:hidden w-10 h-10 bg-white rounded-full flex items-center justify-center text-gray-200 font-bold text-sm flex-shrink-0 transition-all duration-300">
              ${step.number}
            </div>
          </div>

          <!-- Content -->
          <div class="flex-grow sm:flex-grow-0 ml-4 sm:ml-0">
            <div class="text-xs font-semibold text-gray-400 uppercase hidden tracking-wide mb-2 transition-all duration-300">
              ${step.number}
            </div>
            <h3 class="text-lg sm:text-2xl font-semibold text-headingColor mb-4 font-publicSans">
              ${step.title}
            </h3>
            <p class="text-headingLight font-normal font-publicSans tracking-wide text-sm sm:text-base">
              ${step.desc}
            </p>
          </div>

        </div>
      </div>
    `,
    )
    .join("");
}
// =====================

/* ================= COMPLIANCE ================= */
function renderCompliance(compliance) {
  document.querySelector(".compliance-heading").textContent =
    compliance.heading;
  document.querySelector(".compliance-intro").textContent = compliance.intro;

  const container = document.getElementById("compliance-container");
  if (!container) {
    console.error("compliance-container not found");
    return;
  }

  container.innerHTML = compliance.sections
    .map(
      (section) => `
      <article class="bg-offPurple rounded-xl p-4 lg:p-6 transition">
        <h3 class="font-semibold text-base lg:text-lg font-publicSans text-headingColor tracking-wide">
          ${section.title}
        </h3>
        <p class="text-headingLight text-sm mt-3 font-publicSans tracking-wide font-normal">
          ${section.desc}
        </p>
      </article>
    `,
    )
    .join("");
}

/* ================= NEWSLETTER 2 ================= */
function renderNewsLetter2(newsLetter2) {
  document.querySelector(".newsletter2-heading").textContent =
    newsLetter2.heading;
  document.querySelector(".newsletter2-subtext").textContent =
    newsLetter2.subtext;
  document.querySelector(".newsletter2-btn-text").textContent =
    newsLetter2.buttonText;
  document.querySelector(".newsletter2-btn").href = newsLetter2.link;
}

/* ================= OUR TECH STACK ================= */

/* ================= WHY CHOOSE ================= */
function renderWhyChoose(whyChoose) {
  document.querySelector(".whyChoose-heading").textContent = whyChoose.heading;
  document.querySelector(".whyChoose-subtext").textContent = whyChoose.subtext;

  const container = document.getElementById("whyChoose-container");
  if (!container) {
    console.error("whyChoose-container not found");
    return;
  }

  container.innerHTML = whyChoose.items
    .map(
      (item) => `
      <article class="bg-offPurple rounded-xl p-4 lg:p-6 transition">
        <h3 class="font-semibold text-base lg:text-lg font-publicSans text-headingColor tracking-wide">
          ${item.title}
        </h3>
        <p class="text-headingLight text-sm mt-3 font-publicSans tracking-wide font-normal">
          ${item.desc}
        </p>
      </article>
    `,
    )
    .join("");
}

/* ================= CAPABILITIES ================= */
function initAccordion(container) {
  const buttons = container.querySelectorAll("[data-accordion-button]");

  buttons.forEach((button) => {
    button.addEventListener("click", () => {
      const targetId = button.getAttribute("aria-controls");
      const panel = document.getElementById(targetId);
      const isExpanded = button.getAttribute("aria-expanded") === "true";

      // close all other open panels within same container
      buttons.forEach((otherBtn) => {
        const otherId = otherBtn.getAttribute("aria-controls");
        const otherPanel = document.getElementById(otherId);

        otherBtn.setAttribute("aria-expanded", "false");
        otherPanel.style.maxHeight = null;
        otherBtn.querySelector("svg").style.transform = "rotate(0deg)";

        // ← remove open state classes
        otherBtn.classList.remove("bg-white", "text-black");
        otherBtn.classList.add("text-headingColor");
      });

      // toggle clicked panel
      if (!isExpanded) {
        button.setAttribute("aria-expanded", "true");
        panel.style.maxHeight = panel.scrollHeight + "px";
        button.querySelector("svg").style.transform = "rotate(45deg)";

        // ← add open state classes
        button.classList.add("bg-white", "text-black");
        button.classList.remove("text-headingColor");
      }
    });
  });
}

function renderCapabilities(capabilities) {
  document.querySelector(".capabilities-heading").textContent =
    capabilities.heading;
  document.querySelector(".capabilities-subtext").textContent =
    capabilities.subtext;

  const container = document.getElementById("capabilities-container");
  if (!container) {
    console.error("capabilities-container not found");
    return;
  }

  container.innerHTML = capabilities.items
    .map((item, index) => {
      const num = index + 1;
      const id = `faq-cap-${num}`;
      const btnId = `faq-cap-${num}-btn`;
      return `
        <article class="overflow-hidden rounded-2xl">
          <h3>
            <button
              class="w-full px-4 py-4 lg:py-2 lg:pt-6 lg:pb-3 lg:px-6 text-left rounded-tl-2xl rounded-tr-2xl flex items-center justify-between gap-4 focus:outline-none text-lg text-headingColor font-publicSans font-normal tracking-wide"
              aria-expanded="false"
              aria-controls="${id}"
              id="${btnId}"
              data-accordion-button>
              <span class="text-base lg:text-xl leading-6 max-w-[85%] tracking-wide font-medium lg:semibold font-publicSans text-headingColor flex items-start gap-2">
                <span>${num}.</span> ${item.title}
              </span>
              <svg class="w-6 h-6 shrink-0 transition-transform" viewBox="0 0 24 24" fill="none" aria-hidden>
                <path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </button>
          </h3>
          <div
            id="${id}"
            role="region"
            aria-labelledby="${btnId}"
            class="px-0 collapsible max-h-0 bg-white rounded-bl-2xl rounded-br-2xl">
            <p class="text-headingLight text-sm font-publicSans tracking-wide font-normal pb-4 lg:pb-6 pt-0 px-4 lg:px-6">
              ${item.desc}
            </p>
          </div>
        </article>
      `;
    })
    .join("");

  // ← init accordion AFTER innerHTML is injected
  initAccordion(container);
}

/* ================= NEXT GEN TECH ================= */
function renderNextGenTech(nextGenTech) {
  document.querySelector(".nextGenTech-heading").textContent =
    nextGenTech.heading;
  document.querySelector(".nextGenTech-subtext").textContent =
    nextGenTech.subtext;

  const container = document.getElementById("nextGenTech-container");
  if (!container) {
    console.error("nextGenTech-container not found");
    return;
  }

  container.innerHTML = nextGenTech.items
    .map((item) => {
      return `
        <div class="w-full bg-white rounded-xl lg:rounded-3xl p-4 lg:p-6 border">
          <img
            src="${item.image}"
            loading="lazy"
            alt="${item.title}"
            height="32"
            width="32"
            class="w-8 h-8 mb-4"
          />
          <h3 class="text-xl tracking-wide font-semibold text-headingColor mb-3 font-publicSans">
            ${item.title}
          </h3>
          <p class="text-headingLight font-publicSans text-sm sm:text-base tracking-wide mb-3">
            ${item.desc}
          </p>
        </div>
      `;
    })
    .join("");
}

/* ================= HIRE CTA TEAM BANNER ================= */
function renderHireCTATeamBanner(hireCTATeamBanner) {
  document.querySelector(".hireCTA-heading").textContent =
    hireCTATeamBanner.heading;
  document.querySelector(".hireCTA-subtext").textContent =
    hireCTATeamBanner.subtext;
  document.querySelector(".hireCTA-btn-text").textContent =
    hireCTATeamBanner.buttonText;
  document.querySelector(".hireCTA-btn").href = hireCTATeamBanner.link;
}

// our technology section============
function interpolate(container, selectors, keys, payload) {
  selectors.forEach((selector, i) => {
    container.querySelector(selector).textContent = payload[keys[i]];
  });
}

// Our Technology Section
function renderOurTechSection(techStack) {
  interpolate(
    document,
    [".techHeading", ".techPara"],
    ["heading", "intro"],
    techStack,
  );
}

// Another Section (scoped to avoid collision)
function renderAnotherSection(techStack) {
  const section = document.getElementById("another-section2");
  interpolate(
    section,
    [".techHeading", ".techPara"],
    ["heading", "intro"],
    techStack,
  );
}

// main render function change json file with data key
const MAIN_DATA = {
  entriprizeMobile: enterprisePageData,
  agreecultureSoftwere: agriculturePageData,
  javaSoftware: javaPageData,
  generativeAIChatbot: generativeAIChatbotPageData,
  kotlinAppPageJson: kotlinAppPageData,
  swiftIos: iosPageData,
  aspNet: aspNetPageData,
  swiftIos: iosPageData,
  pythonPageJson: pythonAppPageData,
  angularPageDataJson: angularPageData,
  dotNetPageJson: dotNetPageData,
  reactPageJson: reactJSPageData,
};

/* ================= MAIN RENDER ================= */
export function renderPage(name) {
  const data = MAIN_DATA[name];

  renderHero(data.hero);
  renderServices(data.services);
  renderTrutStats(data.trutStats);
  renderAwardSection(data.awardsSection);
  renderMainServices(data.mainServices);
  renderMainServicesMobile(data.mainServices);
  newsLetterFun(data.newsLetter);
  renderCaseStudies(data.caseStudies);
  renderOurProcess(data.ourProcess);
  renderCompliance(data.compliance);
  renderNewsLetter2(data.newsLetter2);
  renderWhyChoose(data.whyChoose);
  renderCapabilities(data.capabilities);
  renderNextGenTech(data.nextGenTech);
  renderHireCTATeamBanner(data.hireCTATeamBanner);
  renderOurTechSection(data.techStack);
  renderAnotherSection(data.techStack);
}
